import { render, staticRenderFns } from "./MDFe.vue?vue&type=template&id=acfe0aaa"
import script from "./MDFe.vue?vue&type=script&lang=js"
export * from "./MDFe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports